import React, { useContext } from 'react';
import { Web3Context } from '../../context/Web3Context';
import './ConnectWallet.css';

export default function ConnectWallet() {
  const { connectWallet, isConnecting, connectionError } = useContext(Web3Context);

  return (
    <div className="connect-page">
      <div className="connect-aurora" />
      <div className="connect-grid-bg" />
      <div className="connect-stars">
        {Array.from({ length: 30 }).map((_, i) => (
          <div key={i} className="connect-star" style={{
            left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 4}s`,
            width: `${1 + Math.random() * 2}px`, height: `${1 + Math.random() * 2}px`
          }} />
        ))}
      </div>

      <div className="connect-content">
        <div className="connect-logo-wrap">
          <div className="connect-logo-ring" />
          <div className="connect-logo-ring connect-logo-ring-2" />
          <div className="connect-logo-ring connect-logo-ring-3" />
          <div className="connect-logo-glow" />
          <img src="/uvw.png" alt="UVW" className="connect-logo" />
        </div>

        <h1 className="connect-title">UVW</h1>
        <p className="connect-tagline">Decentralized Wealth Ecosystem</p>

        <div className="connect-features">
          <div className="connect-feature">
            <div className="connect-feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00e5ff" strokeWidth="1.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
            </div>
            <span className="connect-feature-title">Smart Income</span>
            <span className="connect-feature-desc">6 income streams powered by smart contracts</span>
          </div>
          <div className="connect-feature">
            <div className="connect-feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#a855f7" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
            </div>
            <span className="connect-feature-title">Global Network</span>
            <span className="connect-feature-desc">Worldwide community with auto-level matrix</span>
          </div>
          <div className="connect-feature">
            <div className="connect-feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffd700" strokeWidth="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <span className="connect-feature-title">Secured</span>
            <span className="connect-feature-desc">Transparent on-chain verified contracts</span>
          </div>
        </div>

        <button className="connect-btn" onClick={connectWallet} disabled={isConnecting}>
          <span className="connect-btn-glow" />
          <span className="connect-btn-shine" />
          <span className="connect-btn-text">
            {isConnecting ? 'Connecting...' : 'Connect Wallet'}
          </span>
        </button>

        {connectionError && (
          <div className="connect-error">{connectionError}</div>
        )}

        <div className="connect-badges">
          <span className="connect-badge">Audited</span>
          <span className="connect-badge">On-Chain</span>
          <span className="connect-badge">Transparent</span>
        </div>

        <div className="connect-wallets">
          <span className="connect-wallets-label">Compatible Wallets</span>
          <div className="connect-wallets-list">
            <span className="connect-wallet-tag">Trust Wallet</span>
            <span className="connect-wallet-tag">MetaMask</span>
            <span className="connect-wallet-tag">TokenPocket</span>
            <span className="connect-wallet-tag">DeFi Wallets</span>
          </div>
        </div>

        <div className="connect-footer">
          <span>Powered by opBNB</span>
        </div>
      </div>
    </div>
  );
}
